/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface GetTaskOverviewResponse {
  items: GetTaskOverview[];
  pageIndex: number;
  pageSize: number;
  totalPages: number;
  totalItems: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface GetTaskOverview {
  id: number;
  category: string;
  requestedBy: string;
  requestedFor: string;
  assignee: string;
  description: string;
  extraInfo: object;
  errorMessage?: string;
  payload: string;
  status: Status;
  hyperlinkValue?: string;
  dateCreated: string;
  processType: TaskProcessType;
  triggeredType: TaskTriggeredType;
  childTasks: GetTaskOverview[];
}

/** status */
export type Status =
  | 'created'
  | 'assigned'
  | 'pending'
  | 'waiting'
  | 'waitingForUserInput'
  | 'onHold'
  | 'resolved'
  | 'closed'
  | 'canceled'
  | 'unprocessable'
  | 'userLoginRequired'
  | 'faulted';

/** processType */
export type TaskProcessType = 'manuallyTriggered' | 'auto' | 'orchestration' | 'fullManual';

/** TaskTriggeredType */
export type TaskTriggeredType = 'manual' | 'scheduled' | 'pipeline' | 'orchestrator';

export interface GetTaskDetailResponse {
  id: number;
  requestedBy: string;
  requestedFor: string;
  assignee: string;
  description: string;
  extraInfo: object;
  errorMessage?: string;
  type: string;
  category: string;
  processType: TaskProcessType;
  status: Status;
  hyperlinkValue?: string;
  dateCreated: string;
  payload: string;
}

/** UpdateTaskResponse */
export interface UpdateTaskResponse {
  taskId: number;
  isUpdated: boolean;
  errorMessage?: string;
}

export interface GetEntityResponse {
  entityId: number;
  entityType: string;
  guid: string;
  name: string;
  extraInfo: string;
}

export interface GetTasksOverviewParams {
  pageIndex?: number;
  pageSize?: number;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
  status?: any[];
  category?: string[];
  assignee?: any[];
}

export interface UpdateTaskStatusParams {
  taskStatus: string;
  id: string;
}

export type UpdateTaskPayloadPayload = string;

export interface GetTaskEntitiesParams {
  take?: number;
  search?: string;
  defaultParentOnly?: boolean;
}

import axios, { AxiosInstance, AxiosRequestConfig, ResponseType } from 'axios';

type HeaderValue = string | string[] | number | boolean | null;

interface RawHeaders {
  [key: string]: HeaderValue;
}

interface HeadersDefaults {
  common: RawHeaders;
  delete: RawHeaders;
  get: RawHeaders;
  head: RawHeaders;
  post: RawHeaders;
  put: RawHeaders;
  patch: RawHeaders;
  options?: RawHeaders;
  purge?: RawHeaders;
  link?: RawHeaders;
  unlink?: RawHeaders;
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || 'http://localhost:3000' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data?.response);
  };
}

/**
 * @title TaskModule
 * @version 1.0
 * @baseUrl http://localhost:3000
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description get tasks overview
     *
     * @name GetTasksOverview
     * @summary Your GET endpoint
     * @request GET:/api/task/v2/tasks
     */
    getTasksOverview: (query: GetTasksOverviewParams, params: RequestParams = {}) =>
      this.request<GetTaskOverviewResponse, any>({
        path: `/api/task/v2/tasks`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description get task detail
     *
     * @name GetTaskDetail
     * @summary Your GET endpoint
     * @request GET:/api/task/v2/tasks/{id}
     */
    getTaskDetail: (id: string, params: RequestParams = {}) =>
      this.request<GetTaskDetailResponse, any>({
        path: `/api/task/v2/tasks/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description update task status
     *
     * @name UpdateTaskStatus
     * @request POST:/api/task/v2/tasks/{id}
     */
    updateTaskStatus: ({ id, ...query }: UpdateTaskStatusParams, params: RequestParams = {}) =>
      this.request<UpdateTaskResponse, any>({
        path: `/api/task/v2/tasks/${id}`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description get task categories
     *
     * @name GetTaskCategories
     * @summary Your GET endpoint
     * @request GET:/api/task/v2/tasks/categories
     */
    getTaskCategories: (params: RequestParams = {}) =>
      this.request<string[], any>({
        path: `/api/task/v2/tasks/categories`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description update task payload
     *
     * @name UpdateTaskPayload
     * @request POST:/api/task/v2/tasks/{id}/payload
     */
    updateTaskPayload: (id: string, data: UpdateTaskPayloadPayload, params: RequestParams = {}) =>
      this.request<UpdateTaskResponse, any>({
        path: `/api/task/v2/tasks/${id}/payload`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description execute task
     *
     * @name ExecuteTask
     * @request POST:/api/task/v2/tasks/{id}/execute
     */
    executeTask: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/task/v2/tasks/${id}/execute`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description assign task to current user
     *
     * @name AssignTaskToCurrentUser
     * @request POST:/api/task/v2/tasks/{id}/assigntome
     */
    assignTaskToCurrentUser: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/task/v2/tasks/${id}/assigntome`,
        method: 'POST',
        ...params,
      }),

    /**
     * @description assign task
     *
     * @name AssignTask
     * @request POST:/api/task/v2/tasks/{id}/assign
     */
    assignTask: (
      id: string,
      data: {
        entityId?: number;
        assigneeGuid?: string;
        assigneeType?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/task/v2/tasks/${id}/assign`,
        method: 'POST',
        body: data,
        ...params,
      }),

    /**
     * @description get task entities
     *
     * @name GetTaskEntities
     * @summary Your GET endpoint
     * @request GET:/api/task/v2/tasks/entities
     */
    getTaskEntities: (query: GetTaskEntitiesParams, params: RequestParams = {}) =>
      this.request<GetEntityResponse[], any>({
        path: `/api/task/v2/tasks/entities`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
}
